module.exports = __webpack_public_path__ + "static/media/CDC-Mentions3-FR.9749299d.jpg";